export type AbortErrorFactory = () => Error;

function defaultAbortError(): Error {
  return new DOMException("Operation aborted", "AbortError");
}

/** Shared timeout primitive for ordered UI work that must stop immediately. */
export function abortableDelay(
  durationMs: number,
  signal: AbortSignal,
  abortError: AbortErrorFactory = defaultAbortError,
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) {
      reject(abortError());
      return;
    }

    const onAbort = () => {
      clearTimeout(timer);
      signal.removeEventListener("abort", onAbort);
      reject(abortError());
    };
    const timer = setTimeout(
      () => {
        signal.removeEventListener("abort", onAbort);
        resolve();
      },
      Math.max(0, durationMs),
    );
    signal.addEventListener("abort", onAbort, { once: true });
  });
}
